import { Typography } from "@material-tailwind/react";
import FAQComponent from "./FAQComponent";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";

function ZeitonFAQsComponent() {
  const { t } = useTranslation();
  const faqs = [
    {//TO DO: Change to Zeiton FAQs
      id: "1",
      question: t("ZeitonFaq1Title"),
      answer: t("ZeitonFaq1Description"),
    },
    {
      id: "2",
      question: t("ZeitonFaq2Title"),
      answer: t("ZeitonFaq2Description"),
    },
    {
      id: "3",
      question: t("ZeitonFaq3Title"),
      answer: t("ZeitonFaq3Description"),
    },
    {
      id: "4",
      question: t("ZeitonFaq4Title"),
      answer: t("ZeitonFaq4Description"),
    },
    {
      id: "5",
      question: t("ZeitonFaq5Title"),
      answer: t("ZeitonFaq5Description"),
    },
    {
      id: "6",
      question: t("ZeitonFaq6Title"),
      answer: t("ZeitonFaq6Description"),
    },
    {
      id: "7",
      question: t("ZeitonFaq7Title"),
      answer: t("ZeitonFaq7Description"),
    },
    {
      id: "8",
      question: t("ZeitonFaq8Title"),
      answer: t("ZeitonFaq8Description"),
    },
    {
      id: "9",
      question: t("ZeitonFaq9Title"),
      answer: t("ZeitonFaq9Description"),
    },
  ];

  // Generate FAQ structured data
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqs.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>
      <div className="bg-#F6F6F6 pb-[50px]">
        <Typography variant="h2" className="uppercase text-lg 2xl:text-3xl font-bold tracking-[0.9px] text-center py-[30px] lg:py-[60px]">
          {t("FAQ")}
        </Typography>
        <div className="mx-[20px] lg:mx-[100px] flex flex-col gap-[15px]">
          {faqs.map((faq) => (
            <FAQComponent key={faq.id} faq={faq} />
          ))}
        </div>
      </div>
    </>
  );
}

export default ZeitonFAQsComponent;
